import PolicyService from './PolicyService'

export default PolicyService
